module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-mobilitaetsberatung-b46dfd1f138d294fa279421753f28e60.svg";